import React, { useState, useEffect, useLayoutEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import logo2 from "./logo2.png";
import { firebase } from "../Firebase/config";
// eslint-disable-next-line
import { doc, getDoc, updateDoc, arrayUnion, query, collection, where, getDocs } from "@firebase/firestore";

import { Link } from "react-router-dom";
import "./App.css";
import NavBar from "./Navbar";

function App() {

  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const urlContainsChecker = `${location.pathname}${location.search}${location.hash}`
    .toLowerCase()
    .includes("checker");
  const embeddedInModalFromUrl =
    searchParams.get("embeddedInModal") === "true" ||
    searchParams.get("modal") === "true" ||
    location.hash.toLowerCase().includes("modal");
  const isRunningInsideModal =
    window.self !== window.top ||
    !!window.opener ||
    embeddedInModalFromUrl;
  const isHomePage = !(
    location.pathname.includes("About") ||
    location.pathname.includes("Messages") ||
    location.pathname.includes("Classroom")
  );
  // eslint-disable-line no-unused-vars

  //with teacher access

  //   http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/only2studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  //   http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  //without teacher access

  //   http://localhost:3000/studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  //   http://localhost:3000/only2studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

  // eslint-disable-next-line
  const { only2studentid, studentid, classid, language, id, role } = useParams();

  console.log("YESSS hwooo");

  const [nameofschoool, setNameofschool] = useState();
  const [nameofteacher, setNameofteacher] = useState();
  const [nameofclass, setNameofclass] = useState();
  // eslint-disable-next-line
  const [nameofstudent, setNameofstudent] = useState();

  const [studentidlocal, setstudentidlocal] = useState();

  const [viewparentpage, setViewparentpage] = useState(true);

  const [currenttotal, setCurrenttotal] = useState(0);
  const [hasLoadedLoggedOnCount, setHasLoadedLoggedOnCount] = useState(false);

  const [newwidth, setNewwidth] = useState();

  // Donotshow is used to show the toggle icon that is only worth showing to teachers on the About page. So it is true everywhere but on about page.
  const [donotshow, setDonotshow] = useState();

  const [bringinmenu2, setBringinmenu2] = useState(false);
  const [temparray, setTemparray] = useState([]);

  const [objectofclass, setObjectofclass] = useState();




  //testing gif gmail sent begin






  useEffect(() => {
    console.log("Route pathname:", location.pathname);
    console.log("useParams:", { only2studentid, studentid, classid, language, id, role });

    const missing = [];
    if (!studentid && !only2studentid) missing.push("studentid or only2studentid");
    if (!classid) missing.push("classid");
    if (!id) missing.push("id");

    if (missing.length) {
      console.warn("Missing required route params:", missing);

      // try to recover from localStorage (optional)
      const fallback = localStorage.getItem("currentclass") || localStorage.getItem("myclasses");
      if (fallback) {
        console.log("Found fallback in localStorage, continuing with fallback data");
        // optionally parse & initialize state here, e.g. setTemparray(JSON.parse(fallback)) etc.
        return;
      }

      // Otherwise redirect the user to a safe place
      navigate("/", { replace: true });
    }
  }, [only2studentid, studentid, classid, language, id, role, location.pathname]);
  // ...



  // useEffect(() => {
  //   setTimeout(() => {
  //     setBringinmenu2(true);
  //   }, 2);
  // }, []);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setBringinmenu2(false);
  //   }, 1500);
  // }, []);

  useEffect(() => {
    setDonotshow(true);
  }, []);

  useEffect(() => {
    if (typeof id != "undefined") {
      setstudentidlocal(id);
      getclasses(id)
    }
  }, [id]);



  async function getclasses(id2) {
    try {
      if (!id2) {
        console.error("No valid student ID found in location state");
        alert("Student ID is missing. Please log in again.");
        return;
      }

      const f = query(
        collection(firebase, "classesbeingtaught"),
        where("students", "array-contains", id2)
      );

      const querySnapshot = await getDocs(f);

      if (querySnapshot.empty) {
        console.log("No classes found. Please check your teacher ID." + id2);
        return;
      }

      const array2 = [];

      querySnapshot.forEach((doc) => {
        let user = {
          key: doc.data().id,
          classname: doc.data().classname,
          period: doc.data().period,
          students: doc.data().students,
          googleclassroomid: doc.data().googleclassroomid ? doc.data().googleclassroomid : "",
          googleclassroomname: doc.data().googleclassroomname ? doc.data().googleclassroomname : "",
        };

        array2.push(user);
      });

      localStorage.setItem("myclasses", JSON.stringify(array2));
      setTemparray(array2);
    } catch (error) {
      console.error("Error fetching classes:", error.message || error);
      alert("Failed to fetch classes. Please check the console for details.");
    }
  }

  useEffect(() => {
    if (typeof only2studentid != "undefined") {
      setstudentidlocal(only2studentid);
    }
  }, [only2studentid]);

  useEffect(() => {
    if (typeof studentid != "undefined") {
      setstudentidlocal(studentid);
    }
  }, [studentid]);

  useEffect(() => {
    if (typeof studentid != "undefined") {
      setstudentidlocal(studentid);
    }
    if (typeof only2studentid != "undefined") {
      setstudentidlocal(only2studentid);
    }
  }, []);

  useEffect(() => {
    if (typeof studentidlocal != "undefined") {
      console.log(studentidlocal, "This is the id of the student");
      seeifpersonexists();
    }
  }, [studentidlocal]);

  useEffect(() => {
    if (
      typeof studentidlocal != "undefined" &&
      typeof currenttotal != "undefined" &&
      hasLoadedLoggedOnCount &&
      typeof classid != "undefined" &&
      !urlContainsChecker &&
      !isRunningInsideModal
    ) {
      console.log("current total is about to update", currenttotal);

      let robert = Date.now();

      updateDoc(doc(firebase, "users", studentidlocal), {
        [`${classid}.loggedon`]: currenttotal,
        [`${classid}.loggedontime`]: robert,
      }).catch((error) => {
        console.log(error);
        alert(error);
      });
    } else if (isRunningInsideModal) {
      console.log("Skipping loggedon update because Home is running inside an embedded/modal context");
    }
  }, [currenttotal, studentidlocal, classid, hasLoadedLoggedOnCount, urlContainsChecker, isRunningInsideModal]);

  useEffect(() => {
    if (typeof classid != "undefined") {
      seeifclassexists();
    }
  }, [classid]);

  useEffect(() => {
    if (typeof id != "undefined") {
      seeifteacherexists();
    }
  }, [id]);

  useEffect(() => {
    if (typeof donotshow != "undefined") {
      console.log(donotshow, "hello ");
    }
  }, [donotshow]);

  async function seeifclassexists() {
    const docRef = doc(firebase, "classesbeingtaught", classid);

    const docData = await getDoc(docRef)
      .then(async (userRec) => {
        let object = userRec.data();



        setObjectofclass(object);

        console.log("here is what students are allowed");

        localStorage.setItem("currentclass", JSON.stringify(object));

        localStorage.setItem("nameofteacher", object.teacheriscalled);
        localStorage.setItem("nameofclass", object.classname);


        if (typeof object.classdescription != "undefined") {
          localStorage.setItem("classdescription", object.classdescription);
        } else {
          localStorage.setItem("classdescription", "");

          updateDoc(doc(firebase, "classesbeingtaught", classid), {
            classdescription: "",
          }).catch((error) => {
            console.log(error);
            alert(error);
          });
        }

        if (typeof object.bulletinarray != "undefined") {
          localStorage.setItem(
            "bulletinarray",
            JSON.stringify(object.bulletinarray)
          );
        } else {
          localStorage.setItem("bulletinarray", JSON.stringify([]));

          updateDoc(doc(firebase, "classesbeingtaught", classid), {
            bulletinarray: [],
          }).catch((error) => {
            console.log(error);
            alert(error);
          });
        }
        setNameofteacher(object.teacheriscalled);
        setNameofclass(object.classname);

        console.log(object, "1it found this guy?");
      })
      .catch((error) => {
        // Handle any errors that occur
      })
      .then(async () => {
        console.log("ending rightnow");
      });
  }

  async function seeifpersonexists() {
    console.log(studentidlocal, "heelllito");
    console.log("####1");
    let idd = classid;
    console.log("####1.5", idd);
    console.log(
      "see if personxists function was rrunnn!",
      studentidlocal,
      "student id"
    );

    const docRef2 = doc(firebase, "users", studentidlocal);

    const docData = await getDoc(docRef2)
      .then(async (userRec) => {
        let object2 = userRec.data();

        console.log(object2, "#### 1.75");

        console.log("####2");

        const classRecord = object2 && idd ? object2[idd] : undefined;
        let no = classRecord ? classRecord.loggedon : undefined;
        let lasttime = classRecord ? classRecord.loggedontime : undefined;
        if (typeof no === "undefined") {
          console.log("it was run insided ####4")

          setCurrenttotal(1);
        } else if (typeof no === "number" && !Number.isNaN(no)) {
          // more than 100 minutes ago
          if (
            (typeof lasttime !== "undefined" &&
              !Number.isNaN(lasttime) &&
              Date.now() > lasttime + 3600000)
          ) {
            setCurrenttotal(no + 1);
          } else {
            setCurrenttotal(no);
          }
          console.log("Logged on is there", no);
        } else {
          setCurrenttotal(1);

          console.log("Logged on is not there");
        }

        setHasLoadedLoggedOnCount(true);

        console.log(object2.school, "THIS IS the name of the school!!!!!!!!!!");

        localStorage.setItem("currentstudent", JSON.stringify(object2));

        localStorage.setItem("gclassroomid", object2.googleclassroomid);

        console.log(object2.googleclassroomid, "this is the googleclassroomid");

        localStorage.setItem("nameofstudent", object2.localfirstname);
        setNameofstudent(object2.localfirstname);

        setNameofschool(object2.school);
        console.log(object2, "2it found this guy?");
        console.log(
          object2.recordofnotifications,
          "this is what the OTHER object looks like"
        );
      })
      .catch((error) => {
        // Handle any errors that occur
        setHasLoadedLoggedOnCount(false);
      })
      .then(async () => {
        console.log("ending rightnow");
      });
  }

  async function seeifteacherexists() {
    const docRef2 = doc(firebase, "users", id);

    const docData = await getDoc(docRef2)
      .then(async (userRec) => {
        let object2 = userRec.data();

        if (object2.bulletinarray && Array.isArray(object2.bulletinarray)) {
          console.log("Preloading bulletin images from Home.js");

          const imagesToLoad = object2.bulletinarray.filter(item => item.url && item.makeentryactive);

          if (imagesToLoad.length === 0) {
            // No images to preload, set state immediately
            setObjectofclass(object2);
            localStorage.setItem("aboutobjectofclass", JSON.stringify(object2));
          } else {
            // Track loaded images
            let loadedCount = 0;

            imagesToLoad.forEach(item => {
              const img = new Image();

              img.onload = img.onerror = () => {
                console.log(`${img.complete && img.naturalWidth !== 0 ? "Loaded" : "Failed to load"}: ${item.url}`);
                loadedCount++;
                if (loadedCount === imagesToLoad.length) {
                  console.log("All bulletin images preloaded (some may have failed)");
                  setObjectofclass(object2);
                  localStorage.setItem("aboutobjectofclass", JSON.stringify(object2));
                }
              };

              img.src = item.url;
            });
          }
        } else {
          // No bulletin array, set state immediately
          setObjectofclass(object2);
          localStorage.setItem("aboutobjectofclass", JSON.stringify(object2));
        }
      })
      .catch((error) => {
        console.log("did not get list of classids");
      })
      .then(async () => {
        console.log("done seetting classids");
      });
  }

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;

    return {
      width,
      height,
    };
  }

  const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );

    useLayoutEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
  };

  const { height, width } = useWindowDimensions();

  useEffect(() => {
    if (typeof width != "undefined") {
      setNewwidth(width);
    }
  }, [width]);

  useEffect(() => {
    if (typeof width != "undefined") {
      setNewwidth(width);
    }
  }, []);

  useEffect(() => {
    if (typeof newwidth != "undefined") {
      console.log(newwidth);
    }
  }, [newwidth]);

  return (
    <div className="App22">
      <NavBar
        viewparentpage={isHomePage ? viewparentpage : null}
        setViewparentpage={isHomePage ? setViewparentpage : null}
        donotshow={isHomePage ? donotshow : null}
        bringinmenu2={isHomePage ? bringinmenu2 : null}
        role={isHomePage ? role : null}
        temparray={isHomePage ? temparray : null}
        objectofclass={isHomePage ? objectofclass : null}
      />
      <div
        className="App"
        onClick={() => setBringinmenu2(!bringinmenu2)}
      >
        <header className="App-header2">
          <img
            src={logo2}
            className={newwidth < 800 ? "App-logo2" : "App-logo2big"}
            alt="logo"
            onClick={() => setBringinmenu2(!bringinmenu2)}
          />

          {nameofschoool && nameofclass && nameofteacher && newwidth < 800 ? (
            <div className="App-logo9">
              <p>{nameofschoool}</p>
              <div className="App-logo5">
                <p>- {nameofclass} -</p>
              </div>
              <p> {nameofteacher}</p>
            </div>
          ) : nameofschoool && nameofclass && nameofteacher ? (
            <div className="App-logo9big">
              <p>{nameofschoool}</p>
              <div className="App-logo5big">
                <p>- {nameofclass} -</p>
              </div>
              <p> {nameofteacher}</p>
            </div>
          ) : newwidth < 800 ? (<div className="App-logo9">
            <br />   <br />
            <p className="section5922ax1">FastClassPass is a hallpass{newwidth < 600 ? <br /> : null} and a classroom management<br />tool that provides easy{newwidth < 600 ? <br /> : null} and time-saving methods of<br />documentation{newwidth < 600 ? <br /> : null} and communication.</p>

             <br />
            <br />

         
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
              <Link
                to="/Privacypolicy"
                style={{
                  color: "white",
                  backgroundColor: "black",
                  marginLeft: "auto",
                  marginRight: "auto",
                  borderRadius: "5px",
                  fontSize: "13px",
                  lineHeight: "13px",
                  display: "inline-block",
                }}
              >
                Privacy Policy
              </Link>
              <p style={{ color: "#aaaaaa", fontSize: "13px", margin: 0, textAlign: "center" }}>
                &copy; 2001&ndash;2026 FastClassPass. All rights reserved.
              </p>
            </div>
          </div>) : (<div className="App-logo9big">

            <p className="section5922ax1">FastClassPass is a hallpass{newwidth < 600 ? <br /> : null} and a classroom management<br />tool that provides easy{newwidth < 600 ? <br /> : null} and time-saving methods of<br />documentation{newwidth < 600 ? <br /> : null} and communication.</p>

            <br />
            <br />

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
              <Link
                to="/Privacypolicy"
                style={{
                  color: "white",
                  backgroundColor: "black",
                  marginLeft: "auto",
                  marginRight: "auto",
                  borderRadius: "5px",
                  fontSize: "13px",
                  lineHeight: "13px",
                  display: "inline-block",
                }}
              >
                Privacy Policy
              </Link>
              <p style={{ color: "#aaaaaa", fontSize: "13px", margin: 0, textAlign: "center" }}>
                &copy; 2001&ndash;2026 FastClassPass. All rights reserved.
              </p>
            </div>
          </div>)}

        </header>
      </div>

      {/* place button to call send gmail to mattkrebsemail@gmail.com api here */}


    </div>
  );
}

export default App;